import { forwardRef, useState } from "react";
import { Spinner } from "reactstrap";
import { ReactComponent as EyeIcon } from "assets/images/eye.svg";
import { ReactComponent as EyeSlashIcon } from "assets/images/eye-slash.svg";
import {
  Wrapper,
  IconWrapper,
  EyeWrapper,
  InputField,
  Circle,
  PlaceHolder,
} from "./Input.style.jsx";

const Input = forwardRef(
  (
    { Icon, placeholder, name, isFine, isError, ltr, type = "text", style, onKeyPress, onChange, inputMode },
    ref
  ) => {
    const [inputType, setType] = useState(type);

    const handlePassword = () => {
      if (inputType === "text") setType("password");
      if (inputType === "password") setType("text");
    };

    return (
      <Wrapper isFine={isFine} isError={isError} style={style}>
        <IconWrapper isFine={isFine} isError={isError}>
          {Icon}
        </IconWrapper>
        <InputField
          direction={ltr ? "ltr" : "rtl"}
          type={inputType}
          ref={ref}
          name={name}
          placeholder={placeholder}
          autoComplete="off"
          onKeyPress={onKeyPress}
          onChange={onChange}
          inputMode={inputMode}
        />
        {type === "password" && (
          <EyeWrapper onClick={handlePassword}>
            {inputType === "password" ? (
              <EyeSlashIcon width={20} height={20} />
            ) : (
              <EyeIcon width={20} height={20} />
            )}
          </EyeWrapper>
        )}
      </Wrapper>
    );
  }
);

export const DomainInput = forwardRef(
  ({ name, Icon, isFine, isError, style }, ref) => {
    return (
      <Wrapper isFine={isFine} isError={isError} style={style}>
        <IconWrapper>
          {Icon === "spinner" ? (
            <Spinner size="sm" />
          ) : (
            <Circle isFine={isFine} isError={isError} />
          )}
        </IconWrapper>
        <PlaceHolder>.landin.ir</PlaceHolder>
        <InputField
          name={name}
          ref={ref}
          dir="ltr"
          style={{ width: "72%" }}
          autoComplete="off"
        />
      </Wrapper>
    );
  }
);

export default Input;
